import styles from "./styles.module.scss"

import type { FC, HTMLAttributes } from "react"

interface ItemProps
extends HTMLAttributes<HTMLLIElement> { 
  value: number,
  title: string,
}


export const Item: FC<ItemProps> = ({ value, title, ...props }) => (
  <li className={styles.item} {...props}>
    <p className={styles.value}>{value}+</p>
    <p className={styles.title}>{title}</p>
  </li>
)
